import React, { Component } from "react";
import moment from "moment";
import Multiselect from 'react-widgets/lib/Multiselect';
import DropdownList from 'react-widgets/lib/DropdownList';
import DateTimePicker from 'react-widgets/lib/DateTimePicker'

    export const renderInput = ({ input, label, meta, isLabel }) => {
        const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
        const feedbackMessage = `${meta.error && meta.touched ? 'Borrower last name is required' : ''} `;
        return (
            <div className="form-group">
                {(isLabel) && (<label>{label}</label>)}
                <input {...input} autoComplete="new-password" className={className} placeholder={(!isLabel) && (label)} />
                <div className="invalid-feedback">{meta.error}</div>
            </div>
        );
    };
    export const renderInputField = ({ input, label, meta, isLabel }) => {
        const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
        const feedbackMessage = `${meta.error && meta.touched ? 'Borrower last name is required' : ''} `;
        return (
            <>
                {(isLabel) && (<label>{label}</label>)}
                <input {...input} autoComplete="new-password" className={className} placeholder={(!isLabel) && (label)} />
                <div className="invalid-feedback">{meta.error}</div>
            </>
        );
    };


export const renderTextArea = ({ input, label, meta, isLabel}) => {
    const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
    const feedbackMessage = `${meta.error && meta.touched ? 'Borrower last name is required' : ''} `;
    return (
        <div className="form-group">
            {(isLabel) && (<label>{label}</label>)}
            <textarea {...input} autoComplete="new-password" className={className} placeholder={(!isLabel) && (label)}  />
            <div className="invalid-feedback">{meta.error}</div>
        </div>
    );
};

var DatePicker = require("reactstrap-date-picker");

export const renderDatePicker = ({ input, label,value, defaultValue, meta, isLabel }) => {
    const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
    return (
        <div>
            {(isLabel) && (<label>{label}</label>)}
            <DatePicker {...input} dateFormat="MM/DD/YYYY" 
          //  value={!value ? null : moment(new Date(value)).format('MM/DD/YYYY')} 
            className={className} />
            <div className="invalid-feedback">{meta.error}</div>
        </div>
    )
};
export const renderMultiselect = ({ input, data, valueField, textField,meta,label, isLabel }) => {
    const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
    return (
        <>
            {(isLabel) && (<label>{label}</label>)}
            <Multiselect {...input}
                onBlur={() => input.onBlur()}
                value={input.value || []} // requires value to be an array
                data={data}
                valueField={valueField}
                textField={textField}
            />
        </>)
};
export const renderDropdown = ({ input, data, valueField, textField,meta,label, isLabel }) => {
    const className = `form-control ${meta.error && meta.touched ? 'is-invalid' : ''} `;
    return (
        <>
            {(isLabel) && (<label>{label}</label>)}
            <DropdownList {...input}
                onBlur={() => input.onBlur()}
                value={input.value || []} // requires value to be an array
                data={data}
                valueField={valueField}
                textField={textField}
            />
        </>)
};

export const renderCheckbox = ({input, label, meta, isLabel}) => {
    return (
        <div className="form-group">
            {(isLabel) && (<label>{label}</label>)}
            <div>
            <input {...input}  type="checkbox" />
            </div>
        </div>
    )
}